module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('canvas', {
    ref: "chart"
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-80d36dd4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/BarChart.vue
// module id = 1489
// module chunks = 1